import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg width={22} height={26} viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <Path
        d="M22 13a1.967 1.967 0 01-.95 1.689L3.04 25.706a2 2 0 01-2.767-.688A1.983 1.983 0 010 24.016V1.984A1.983 1.983 0 011.015.256 2 2 0 013.04.294L21.05 11.31A1.967 1.967 0 0122 13z"
        fill="#FA2323"
      />
    </Svg>
  );
}

export default SvgComponent;
